import { IProfile, Phase } from '../types';
import { setCookie } from '@unified-checkout/kit-components';
import { getUserData } from '../utils';

type useStoreUserDataProps = {
  data?: IProfile;
  currentPhase?: Phase;
};
export const useStoreUserData = () => {
  const handler = ({ data, currentPhase }: useStoreUserDataProps) => {
    const latestCookieData = getUserData();
    let payload = {
      ...(latestCookieData && latestCookieData),
      ...(data && data),
      ...(currentPhase && { currentPhase }),
    };
    setCookie('fastCheckoutAccount', JSON.stringify(payload), {
      expirationDate: payload.sessionToken?.expirationDate,
    });
  };

  return handler;
};
